module.exports = __webpack_public_path__ + "resources/img/img_ontune_vm_sms_en.fb2a045c8e79107678a5ad4303573e9f.png";